import RoutePaths from '../../../routes/RoutePaths';

/*
 * File: Sidebar-data.tsx
 * Project: a-a
 * File Created: Tuesday, 5th November 2024 10:02:02 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 29th October 2025 10:43:22 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
interface ISidebarData {
  title: string;
  path: string;
  icon: string;
}

const SidebarData: { main: ISidebarData[]; app: ISidebarData[]; quickLinks: ISidebarData[] } = {
  main: [
    {
      title: 'Dashboard',
      path: RoutePaths.Home,
      icon: '/assets/dashboard-logo.svg',
    },
    {
      title: 'Client',
      path: RoutePaths.Client,
      icon: '/assets/client.svg',
    },
    {
      title: 'Team',
      path: RoutePaths.Team,
      icon: '/assets/team.svg',
    },
  ],
  app: [
    {
      title: 'Asana',
      path: RoutePaths.Asana,
      icon: '/assets/asana-logo.png',
    },
    {
      title: 'ZoomInfo',
      path: RoutePaths.ZoomInfo,
      icon: '/assets/zoominfo-logo.svg',
    },
  ],
  quickLinks: [
    {
      title: 'Salesforce',
      path: `https://${process.env.REACT_APP_SALESFORCE_URI}`,
      icon: '/assets/salesforce.png',
    },

    {
      title: 'Captiv8',
      path: 'https://captiv8.io/insights/signin',
      icon: '/assets/captiv8-icon.svg',
    },
    {
      title: 'Slack',
      path: `https://slack.com/intl/en-au/signin#/signin`,
      icon: '/assets/slack-nav-icon.svg',
    },
  ],
};

export default SidebarData;
